<template>
  <div :class="{'border-b border-gray-500': popped, '-mt-px': !popped}">
    <div class="flex" :class="tabStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  data() {
    return {};
  },
  props: {
    bright: {
      type: Boolean,
      default: false
    },
    css: {
      type: String,
      default: "bg-gray-300"
    },
    popped: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  methods: {},
  computed: {
    tabStyle() {
      let tabStyle = " " + this.css;
      if (this.bright) {
        tabStyle += "bg-transparent";
      }
      if (this.popped) {
        tabStyle += " mx-4";
      }
      return tabStyle;
    }
  },
  created() {}
};
</script>
